import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import {Box} from "@material-ui/core";

const ScheduleSkeleton = (props) => {
    return <Box flex={'1 0 auto'} display={'flex'} flexDirection={'column'}>
    <Box display={'flex'} pt={1} pb={2} justifyContent={'space-between'}>
        <Skeleton variant="rect" width={100} height={40} />
        <Box display={'flex'} justifyContent={'space-between'} flexBasis={'170px'}>
            <Skeleton variant="rect" width={50} height={40} />
            <Skeleton variant="rect" width={100} height={40} />
        </Box>
    </Box>
    <Box display={'flex'} flex={1} style={{gap:'5px'}}>
        <Skeleton variant="rect" style={{flex:1,height: 'unset'}} />
        <Skeleton variant="rect" style={{flex:1,height: 'unset'}} />
        <Skeleton variant="rect" style={{flex:1,height: 'unset'}} />
        <Skeleton variant="rect" style={{flex:1,height: 'unset'}} />
        <Skeleton variant="rect" style={{flex:1,height: 'unset'}} />
    </Box>
    </Box>
}

export default ScheduleSkeleton;